import React, { useEffect, useState } from "react";
import ListaOrdini from "./DBperAreaOrdiniComponenti/ListaOrdini";
import BarraRicercaOrdini from "./DBperAreaOrdiniComponenti/BarraRicercaOrdini";
import BarraFunzioniOrdini from "./DBperAreaOrdiniComponenti/BarraFunzioniOrdini";
import stilePulsanti from "../../interfaccia/stilePulsanti.js";
import { useAuth0 } from "@auth0/auth0-react";
import ColonneOrdiniPanel from "./DBperAreaOrdiniComponenti/ColonneOrdiniPanel";
import useColumnPreferences from "./DBperAreaOrdiniComponenti/useColumnPreferences";
import { ORDINI_COLUMN_IDS, ORDINI_LOCKED_COLUMN_IDS } from "./DBperAreaOrdiniComponenti/ordiniColumnMetadata";

function DBperAreaOrdini({
  setOrdineFunction,
  urlRicerca,
  setUrlRicerca,
  limiteRighe,
  setLimiteRighe,
  setResImport,
  totalRows,
  setTotalRows,
  perPage,
  setPerPage,
  page,
  setPage,
  urlParametri,
  setUrlParametri,
  datiTendineOrdine,
  ricerca,
  tema,
  utente,
  selezioneCampiRicerca,
  inputIniziale,
  setInputIniziale,
  columnSort,
  directionSort,
  fetchOrdini,
  handlePageChange,
  handlePerRowsChange,
  handleSort,
  setRigheSelezionate,
  righeSelezionate,
  data,
  loading,
  deseleziona,
  setDeseleziona,
  setData,
  setRicerca,
  inputVuoto,
  mobile,
  perPageOptions,
  setVista,
  urlRicercaINIT,
  ricercaIniz,
  setLoading,
  setListeOrdiniDaAltrove,
  setVistaConReset,
  filtroVeloce,
  setFiltroVeloce,
  vista,
}) {
  const { user } = useAuth0();
  const columnPreference = useColumnPreferences(user?.sub, "dbOrdini", "ordini", ORDINI_COLUMN_IDS, ORDINI_LOCKED_COLUMN_IDS);
  const mostraColonneOrdini = (!vista || vista === "ordini") && !mobile;
  const columnControl = mostraColonneOrdini ? (
    <ColonneOrdiniPanel
      preference={columnPreference}
      sortField={columnSort}
      sortDirection={directionSort}
    />
  ) : null;
  useEffect(() => {
    fetchOrdini(page);
  }, [vista]);

  const [alertSalvataggio, setAlertSalvataggio] = useState(false);

  return (
    <div class="center">
      <div class="cf contentSubSubHeader ">
        <div class="fl-ns pr4 pl3 bb bordoColAlt sfondoBiancoTema">
          {/* questa sotto è la seconda riga della barra, per vista mobile */}
          {mobile && righeSelezionate.length < 1 && (
            <BarraRicercaOrdini
              vista={"mobile2"}
              setListaOrdini={setData}
              setUrlRicerca={setUrlRicerca}
              inputVuoto={inputVuoto}
              urlRicerca={urlRicerca}
              inputIniziale={inputIniziale}
              selezioneCampiRicerca={selezioneCampiRicerca}
              setOrdineFunction={setOrdineFunction}
              setResImport={setResImport}
              perPage={perPage}
              page={page}
              setTotalRows={setTotalRows}
              setUrlParametri={setUrlParametri}
              datiTendineOrdine={datiTendineOrdine}
              tema={tema}
              setRicerca={setRicerca}
              columnSort={columnSort}
              directionSort={directionSort}
              ricerca={ricerca}
              setPerPage={setPerPage}
              setPage={setPage}
              mobile={false} // perché è riga sopra, con i tasti per le viste
              setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
              setVistaConReset={setVistaConReset}
              listaOrdini={data}
              utente={utente}
              fetchOrdini={fetchOrdini}
            />
          )}
          {righeSelezionate.length < 1 && (
            <BarraRicercaOrdini
              setListaOrdini={setData}
              limiteRighe={limiteRighe}
              setLimiteRighe={setLimiteRighe}
              righeSelezionate={righeSelezionate}
              setUrlRicerca={setUrlRicerca}
              setOrdineFunction={setOrdineFunction}
              setResImport={setResImport}
              perPage={perPage}
              page={page}
              setTotalRows={setTotalRows}
              urlParametri={urlParametri}
              setUrlParametri={setUrlParametri}
              datiTendineOrdine={datiTendineOrdine}
              tema={tema}
              selezioneCampiRicerca={selezioneCampiRicerca}
              inputIniziale={inputIniziale}
              urlRicerca={urlRicerca}
              setRicerca={setRicerca}
              columnSort={columnSort}
              directionSort={directionSort}
              inputVuoto={inputVuoto}
              setInputIniziale={setInputIniziale}
              setVista={setVista}
              urlRicercaINIT={urlRicercaINIT}
              ricercaIniz={ricercaIniz}
              setPerPage={setPerPage}
              mobile={mobile}
              setLoading={setLoading}
              setPage={setPage}
              setListeOrdiniDaAltrove={setListeOrdiniDaAltrove}
              setVistaConReset={setVistaConReset}
              filtroVeloce={filtroVeloce}
              setFiltroVeloce={setFiltroVeloce}
              listaOrdini={data}
              vista={vista}
              utente={utente}
              fetchOrdini={fetchOrdini}
              columnControl={columnControl}
            />
          )}
          {righeSelezionate.length > 0 &&
            !mobile &&
            (utente?.permessiAPI?.["update:logistica"] || utente?.permessiAPI?.["print:logistica"]) && (
              <BarraFunzioniOrdini
                canUpdateLogistica={Boolean(utente?.permessiAPI?.["update:logistica"])}
                righeSelezionate={righeSelezionate}
                page={page}
                fetchOrdini={fetchOrdini}
                setRigheSelezionate={setRigheSelezionate}
                setDeseleziona={setDeseleziona}
                deseleziona={deseleziona}
                setRicerca={setRicerca}
                setVistaConReset={setVistaConReset}
                datiTendineOrdine={datiTendineOrdine}
                tema={tema}
                urlRicerca={urlRicerca}
                setUrlRicerca={setUrlRicerca}
                inputVuoto={inputVuoto}
                perPage={perPage}
                setTotalRows={setTotalRows}
                vista={vista}
                setListaOrdini={setData} /* controllare questo */
                setAlertSalvataggio={setAlertSalvataggio}
                columnControl={columnControl}
              />
            )}
          {righeSelezionate.length > 0 && !mobile &&
            !utente?.permessiAPI?.["update:logistica"] &&
            !utente?.permessiAPI?.["print:logistica"] && columnControl && (
              <div className="formRicercaOrizzontale pa2 flex justify-end items-center w-100">{columnControl}</div>
            )}
        </div>
        {alertSalvataggio && (
          <div className={stilePulsanti.buttonClassesRed + " pa4 f4"}>
            {alertSalvataggio}
          </div>
        )}
        <div class="fl-ns w-100 w-100-ns sfondoBiancoTema">
          <ListaOrdini
            setOrdineFunction={setOrdineFunction}
            listaOrdini={data}
            setListaOrdini={setData}
            righeSelezionate={righeSelezionate}
            setRigheSelezionate={setRigheSelezionate}
            loading={loading}
            totalRows={totalRows}
            handlePerRowsChange={handlePerRowsChange}
            handlePageChange={handlePageChange}
            perPage={perPage}
            deseleziona={deseleziona}
            utente={utente}
            handleSort={handleSort}
            columnSort={columnSort}
            directionSort={directionSort}
            mobile={mobile}
            perPageOptions={perPageOptions}
            ricerca={ricerca}
            page={page}
            setVistaConReset={setVistaConReset}
            vista={vista}
            ordiniColumnVisibility={mostraColonneOrdini ? columnPreference.columns : undefined}
            ordiniColumnOrder={mostraColonneOrdini ? columnPreference.order : undefined}
            onOrdiniColumnOrderChange={mostraColonneOrdini && columnPreference.ready ? columnPreference.reorder : undefined}
            enableOrdiniColumns={mostraColonneOrdini}
          />
        </div>
      </div>
    </div>
  );
}

export default DBperAreaOrdini;
